import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './EAFConserveRecord.module.css'
import { getEAFConserveListAsync, getEAFConserveExportAsync } from '../EAFConserve/EAFConserveSlice'

export const EAFConserveRecordList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [exportLoading, setExportLoading] = useState<any>(false)

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getEAFConserveListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '5') {
        getDataList()
    }
  }, [queries, props?.selectKey])

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getEAFConserveExportAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '设备设施养护记录.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          add={() => {
            setIsModalVisible(true)
            setId('')
          }}
          exportLoading={exportLoading}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
          }}
          export={() => {
            exportExcel()
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((text, t: any) => {
            return
          }, (queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
    </Col>
  )
}
